// extracted by mini-css-extract-plugin
export var wrapper = "layout-module--wrapper--5UXpi";